<!--
 * @Author: pyy
 * @Date: 2022-09-16
 * @Description: 县区统计-饼状图
-->
<template>
	<div class="pie-chart h100 pdb10"
		 ref="pieChart">
		<div v-for="item in num"
			 :key="item"
			 ref="myChart"
			 class="myChart"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import * as API from '@/api/FormManager/FormManager'
import { mapState } from 'vuex'
import { html2canvasExport } from '@/utils/tools'

export default {
	props: {
		apiParams: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			num: 1,
			optionsList: [],
			chartList: [],
		}
	},
	created() {},
	mounted() {
		window.addEventListener('resize', () => {
			setTimeout(() => {
				for (let index = 0; index < this.num; index++) {
					if (!!this.chartList[index]) {
						this.chartList[index].resize()
					}
				}
			}, 200)
		})
	},
	methods: {
		_getData() {
			API.getCityStatisticsToPieChart(this.apiParams).then((res) => {
				if (!!res.data) {
					const areaKeys = Object.keys(res.data)
					console.log(areaKeys)
					// 图表数量
					this.num = areaKeys.length

					let dataArr = areaKeys.map((item) => {
						// 用别名找到区域名
						let area = {}
						this.projectDict.xmgsqy.map((i) => {
							if (item === i.alias) {
								area = i
							}
						})
						return {
							title: item === 'total' ? '片区' : area.sname,
							alias: item,
							...res.data[item], // 四个值
						}
					})

					this.optionsList = []
					this.chartList = []

					dataArr.map((item) => {
						const { title, alias, plan, declare, examine, actual } =
							item
						const legendName =
							alias === 'total' ? '片区累计总' : title + '累计'

						this.optionsList.push({
							title: {
								text: title,
								left: 'center',
								top: '15',
								textStyle: {
									fontSize: 18,
									fontWeight: 'bolder',
									color: '#1e1e1e',
								},
							},
							tooltip: {
								trigger: 'item',
							},
							color: ['#38bf98', '#00b2ee', '#ffcc00', '#6699ff'],
							legend: {
								orient: 'vertical',
								top: 'middle',
								right: '3%',
								itemWidth: 20,
								itemHeight: 20,
								textStyle: {
									color: '#666',
								},
							},
							toolbox: {
								show: true,
								feature: {
									mark: {
										show: true,
									},
									saveAsImage: {
										show: true,
										pixelRatio: 1,
										title: '保存为图片',
										type: 'png',
										lang: ['点击保存'],
										name: `东部新中心建设项目${title}产值统计饼状图`,
									},
								},
							},

							series: [
								{
									type: 'pie',
									radius: '55%',
									right: '100',
									center: ['30%', '55%'],
									label: {
										show: true,
										formatter:
											'{b}' +
											'\n\r' +
											'{c}' +
											(this.apiParams.unit == 0
												? '元'
												: '万元'),
										lineHeight: 18,
									},
									data: [
										{
											value: plan,
											name: legendName + '计划完成产值',
											label: {
												color: '#38bf98',
											},
										},
										{
											value: declare,
											name: legendName + '申报完成产值',
											label: {
												color: '#00b2ee',
											},
										},
										{
											value: examine,
											name: legendName + '审核完成产值',
											label: {
												color: '#ffcc00',
											},
										},
										{
											value: actual,
											name: legendName + '实际付款',
											label: {
												color: '#6699ff',
											},
										},
									],
								},
							],
						})
					})

					setTimeout(() => {
						this.initChart()
					}, 200)
				}
			})
		},

		initChart() {
			this.optionsList.map((item, index) => {
				const chartItem = echarts.init(this.$refs.myChart[index])
				chartItem.setOption(item, true)
				this.chartList.push(chartItem)
			})
		},

		download() {
			if (this.$refs.pieChart) {
				// const domWrap = this.$refs.pieChart
				// domWrap.style.position = 'absolute'
				// domWrap.style.top = '60px'

				html2canvasExport(
					this.$refs.pieChart,
					'东部新中心建设项目产值统计图'
				)
				// domWrap.style.position = 'static'
				// domWrap.scrollTo(0, 0)
			}
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
	watch: {
		apiParams: {
			handler(newVal) {
				this._getData()
			},
		},
		deep: true,
		immediate: true,
	},
}
</script>

<style lang="less" scoped>
.pie-chart {
	display: flex;
	flex-wrap: wrap;
	overflow-y: auto;
	background-color: #fff;
	.myChart {
		width: 50%;
		// height: 377px;
		height: 50%;
		border: 1px solid #ccc;
	}
}
</style>